import { createStore, applyMiddleware } from 'redux'
import createSagaMiddleware from 'redux-saga';
import rootReducer from './SHARED/reducers/index'
import { composeWithDevTools } from 'redux-devtools-extension';
import rootSaga from './SHARED/sagas/root.saga';
import { connectRouter, routerMiddleware } from 'connected-react-router'
import history from './history';
import { REFRESH_TOKEN_AUTH } from "./SHARED/actions/types";

const initialState = {};
const sagaMiddleware = createSagaMiddleware();

const refreshTokenMiddleware = store => next => action => {
    if(action.refresh && window.localStorage.getItem('login_type') === 'authenticated') {
        let today = new Date();
        let currTimestamp = today.getTime();
        let diffSeconds = Math.floor((window.localStorage.getItem('expires_in') - currTimestamp) / 1000);

        //less than 3 days until expiration
        if(diffSeconds < 259200) {
            store.dispatch({
                type: REFRESH_TOKEN_AUTH,
                payload: window.localStorage.getItem('refresh_token')
            });
        }

        next(action);
    } else {
        next(action);
    }
};

const store = createStore(
    //rootReducer,
    connectRouter(history)(rootReducer), // new root reducer with router state
    initialState,
    composeWithDevTools(applyMiddleware(routerMiddleware(history), sagaMiddleware, refreshTokenMiddleware))
);
sagaMiddleware.run(rootSaga);
export default store;



// WEBPACK FOOTER //
// ./src/store.js